import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AutoSaveState } from '@configuration/shared/auto-save/auto-save.directive';

/**
 * The auto-save feedback that replaced the manual save button in each settings
 * card. Takes one `AutoSaveDirective` state, or several when a card auto-saves
 * more than one field (the emails cards) and shows a single aggregated status.
 */
@Component({
  selector: 'app-auto-save-status',
  templateUrl: './auto-save-status.component.html',
  styleUrls: ['./auto-save-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AutoSaveStatusComponent {
  @Input() public states: AutoSaveState | AutoSaveState[] = 'idle';

  public get state(): AutoSaveState {
    const states: AutoSaveState[] = Array.isArray(this.states)
      ? this.states
      : [this.states];

    // Worst news first: a failure must not be hidden by a sibling field that
    // saved fine.
    if (states.indexOf('error') > -1) {
      return 'error';
    }

    if (states.indexOf('saving') > -1) {
      return 'saving';
    }

    if (states.indexOf('saved') > -1) {
      return 'saved';
    }

    return 'idle';
  }
}
